/* tslint:disable */
/* eslint-disable */
/**
 * ELOfleet API Documentation
 * Backend of the ELOfleet fleet management system
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SafetyMessageUpdate
 */
export interface SafetyMessageUpdate {
    /**
     * 
     * @type {string}
     * @memberof SafetyMessageUpdate
     */
    body?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof SafetyMessageUpdate
     */
    active?: boolean | null;
}

/**
 * Check if a given object implements the SafetyMessageUpdate interface.
 */
export function instanceOfSafetyMessageUpdate(value: object): value is SafetyMessageUpdate {
    return true;
}

export function SafetyMessageUpdateFromJSON(json: any): SafetyMessageUpdate {
    return SafetyMessageUpdateFromJSONTyped(json, false);
}

export function SafetyMessageUpdateFromJSONTyped(json: any, ignoreDiscriminator: boolean): SafetyMessageUpdate {
    if (json == null) {
        return json;
    }
    return {
        
        'body': json['body'] == null ? undefined : json['body'],
        'active': json['active'] == null ? undefined : json['active'],
    };
}

export function SafetyMessageUpdateToJSON(json: any): SafetyMessageUpdate {
    return SafetyMessageUpdateToJSONTyped(json, false);
}

export function SafetyMessageUpdateToJSONTyped(value?: SafetyMessageUpdate | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'body': value['body'],
        'active': value['active'],
    };
}

